import { extendObservable, runInAction } from 'mobx';

import { ShippingOptionsController } from '../../../../networking/controllers/ShippingOptionsController';
import { Logger } from '../../../../helpers/Logger';

class ShippingInfoStoreClass {
  constructor() {
    extendObservable(this, {
      shippingInfo: null,
      loadingShippingInfo: false,
      error: false,
    });
  }

  async getShipingInfo(locationId) {
    runInAction(() => {
      this.loadingShippingInfo = true;
      this.error = false;
    });
    try {
      const shippingInfo = await ShippingOptionsController.getByLocation(locationId);
      runInAction(() => {
        this.shippingInfo = shippingInfo || {};
      });
    } catch (error) {
      Logger.warn(error);
      runInAction(() => {
        this.error = true;
      });
    } finally {
      runInAction(() => {
        this.loadingShippingInfo = false;
      });
    }
  }

  clearError() {
    runInAction(() => {
      this.error = false;
    });
  }
}

const ShippingInfoStore = new ShippingInfoStoreClass();

export { ShippingInfoStore };



// WEBPACK FOOTER //
// ./src/pages/information/shipping/stores/ShippingInfoStore.js